import React from "react";

import HeroButton from "./HeroButton";

interface CatalogHeroSectionProps {
    botIconSrc: string;
    titletag?: string;
    title?: string;
    description?: string;
}

const CatalogHeroSection: React.FC<CatalogHeroSectionProps> = (props) => {
    const {
        botIconSrc,
        titletag,
        title = "Enable customers to buy, on the fly.",
        description = "Bring a new level of convenience and interactivity to eCommerce on WhatsApp.",
    } = props;
    return (
        <header className="max-w-6xl lg:pt-20 pt-0 mx-auto lg:px-0 px-2">
            <div className="flex flex-col lg:flex-row justify-center md:justify-between pb-8">
                <div className="lg:w-1/2 gap-1 flex flex-col my-10">
                    {titletag && (
                        <div
                            className="text-green-700 bg-green-200 wati-top-green justify-center items-center lg:text-base font-bold whatsapp-drip flex flex-nowrap w-fit m-auto md:m-0"
                            style={{ padding: "5px 12px", borderRadius: "50px", border: "0.5px solid rgb(9, 146, 80)" }}
                        >
                            (
                            <>
                                <p className=" lg:text-base text-xs">{titletag}</p>
                                <span className="wa-control-img">
                                    <img
                                        alt="whatsapp-icon"
                                        height="24px"
                                        width="24px"
                                        src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg"
                                        className="ml-2"
                                    />
                                </span>
                            </>
                            )
                        </div>
                    )}

                    <span className=" text-center lg:text-left mt-4">
                        <h1 style={{ marginBottom: "24px" }} className="lg:text-4xl lg:leading-tight leading-normal text-3xl font-bold text-gray-600">
                            {title}
                        </h1>
                        <span className="text-gray-600 lg:text-xl text-md font-normal text-center w-full pb-8 ">{description}</span>
                    </span>

                    <HeroButton />
                </div>
                <div className="lg:w-1/2">
                    <div className="landing-right-banner px-4 mt-8 mx-auto">
                        <img src={botIconSrc} width="544px" height="421px" alt="WhatsApp Drip Marketing" />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default CatalogHeroSection;
